


import React, { useState } from "react";
import MainLayouts from "../../Layout/MainLayouts";
// import { ReactComponent as ArrowLeftSquare } from "bootstrap-icons/icons/arrow-left-square-fill.svg";
import axios from "axios";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
import ApiServices from "../../api/ApiServices";
import { toast } from "react-toastify";
import { Link, useNavigate, } from "react-router-dom";
import { handleError } from "../../components/utils/AuthenticationCheck";
import AxiosApiCall from "../../api/AxiosApiCall";

const CreateClusterLocation = () => {
    const [address, setAddress] = useState("");
    const [amount, setAmount] = useState("");
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    // Validation function
    const validateForm = () => {
        if (!address) {
            toast.error("Address fields are required.");
            return false;
        }
        if (!amount) {
            toast.error("Amount fields are required.");
            return false;
        }
        if (isNaN(amount) || Number(amount) < 0) {
            toast.error("Amount must be a valid non-negative number.");
            return false;
        }
        return true;
    };


    //axios api encryption call
    const axios = AxiosApiCall();

    // handle submit button
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setLoading(true);
        const formData = {
            address,
            amount: Number(amount),
        };
        console.log("this is my form data", formData);

        try {
            const authData = JSON.parse(localStorage.getItem("auth"));
            const token = authData?.token;
            if (!token) {
                throw new Error("No access token found.");
            }

            const response = await axios.post(
                ApiServices.createClusterLocation,
                formData,

                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    withCredentials: true,
                }
            );

            const { status, message } = response.data;
            if (status === 200) {
                navigate("/admin/cluster/location");
                toast.success(message, { toastId: "cluster-location-created-success" });
                // toast.success(message);
            } else {
                handleError({ response: { status, data: { message } } }, navigate);
            }
        } catch (error) {
            handleError(error, navigate);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <MainLayouts>
                <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
                    {/* form here */}
                    <section className=" body-font">
                        <div className="container px-5 pb-2 mx-auto ">
                            <section
                                className="w-full  pr-[3%] pt-3 my-3"
                                style={{ backgroundColor: "#F7F7F7" }}
                            >
                                <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                                    <ol className="list-none p-0 inline-flex mb-2">
                                        <li className="flex items-center">
                                            <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                                Cluster Point
                                            </p>
                                            <ChevronRightIcon />
                                        </li>

                                        <li className="flex items-center">
                                            <p className="text-orange1">Create</p>
                                        </li>
                                    </ol>
                                </nav>
                            </section>
                            <div className="lg:w-full md:w-full bg-white rounded-lg p-8 flex flex-col md:ml-auto w-full mt-10 md:mt-0 relative z-10 shadow-md bg-dGrey3">
                                <form onSubmit={handleSubmit}>
                                    <div className="d-flex">
                                        <div className="w-full mb-3">
                                            <label
                                                htmlFor="name"
                                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                            >
                                                Amount
                                            </label>
                                            <input
                                                type="number"
                                                name="value"
                                                value={amount}
                                                onChange={(e) => setAmount(e.target.value)}
                                                className="border border-grey3 p-2 rounded-md w-full"
                                            
                                            />
                                        </div>
                                        <div className="w-full mb-3">
                                            <label
                                                htmlFor="name"
                                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                            >
                                                Address
                                            </label>
                                            <textarea
                                                id="value"
                                                name="value"
                                                value={address}
                                                onChange={(e) => setAddress(e.target.value)}
                                                className="border border-grey3 p-2 rounded-md w-full"
                                                rows="4"
                                            />
                                        </div>

                                    </div>
                                    <div className="flex flex-col gap-4 md:flex-row md:gap-4 md:justify-end mt-4">
                                        <Link
                                            to="/admin/cluster/location"
                                            className="text-dGrey3 py-3 bg-black2 hover:bg-blue-800 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 text-center flex items-center"
                                        >
                                            <List className="mr-2" />
                                            Back To List
                                        </Link>
                                        <button
                                            type="submit"
                                            className={`text-white bg-darkGreen3 text-dGrey3 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded font-medium ${loading ? "btn-loading" : "btn-primary"
                                                }`}
                                            disabled={loading}
                                        >
                                            {loading ? "Loading..." : "Add Address"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </section>
                </div>
            </MainLayouts>
        </div>
    );
};

export default CreateClusterLocation;
